import { combineReducers } from '@reduxjs/toolkit';
import { reducer as formReducer } from 'redux-form';
import accountReducer from './accountReducer';
import cartReducer from './cartReducer';

import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const reducers = combineReducers({
    account: persistReducer(
        {
            key: 'account',
            storage,
            keyPrefix: 'datta-'
        },
        accountReducer
    ),
    form: formReducer,
    cart: persistReducer(
        {
            key: 'cart',
            storage,
            keyPrefix: 'datta-'  // Puedes usar un prefijo diferente si prefieres
        },
        cartReducer
    )
});

export default reducers;